import { render, staticRenderFns } from "./AgendaAtendimentos.vue?vue&type=template&id=3d976dc8"
import script from "./AgendaAtendimentos.vue?vue&type=script&lang=js"
export * from "./AgendaAtendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports